var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MenuItem, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EScopeSelector, } from "./types";
import { PINNED_BY_POST, selectorWords } from "./lib/scopeLabel";
/** Region · Post · Country, applying to every widget that follows them; laid out by the header. */
export function MonitoringSelectors(_a) {
    var selectors = _a.selectors, scope = _a.scope, onChange = _a.onChange, options = _a.options, settings = _a.settings, restricted = _a.restricted, pinnedPost = _a.pinnedPost;
    var t = useTranslation().t;
    var shown = selectors.filter(function (selector) { return !(pinnedPost && PINNED_BY_POST.has(selector)); });
    if (!shown.length)
        return null;
    var choicesOf = function (selector) {
        switch (selector) {
            case EScopeSelector.REGION:
                return options.regions;
            case EScopeSelector.POST:
                // Once a region is chosen, only its Posts.
                return options.posts.filter(function (post) { return !scope.region || !post.region || post.region === scope.region; });
            case EScopeSelector.COUNTRY:
                return options.countries;
        }
    };
    var change = function (selector, key) {
        var next = __assign({}, scope);
        if (key)
            next[selector] = key;
        else
            delete next[selector];
        if (selector === EScopeSelector.REGION && next.post && key) {
            var post = options.posts.find(function (option) { return option.key === next.post; });
            if ((post === null || post === void 0 ? void 0 : post.region) && post.region !== key)
                delete next.post;
        }
        onChange(next);
    };
    return (_jsx(_Fragment, { children: shown.map(function (selector) {
            var _a;
            var words = selectorWords(selector, settings, t, restricted);
            var choices = choicesOf(selector);
            var value = (_a = scope[selector]) !== null && _a !== void 0 ? _a : "";
            return (_jsxs(TextField, { id: "monitoring-scope-".concat(selector), select: true, size: "small", label: words.label, value: choices.some(function (choice) { return choice.key === value; }) ? value : "", onChange: function (event) { return change(selector, event.target.value); }, 
                // "All" is the empty value, and is shown as a choice.
                slotProps: { select: { displayEmpty: true }, inputLabel: { shrink: true } }, fullWidth: false, sx: { width: { xs: "100%", md: 190 } }, children: [_jsx(MenuItem, { value: "", children: words.all }), choices.map(function (choice) { return (_jsx(MenuItem, { value: choice.key, children: choice.label }, choice.key)); })] }, selector));
        }) }));
}
